var RangeModel = /** @class */ (function () {
    function RangeModel(min, max, isSm, step, prefix, suffix) {
        this._value = 0;
        this._width = 0;
        this._isSm = false;
        this._min = min;
        this._max = max;
        this._isSm = isSm;
        this._step = step;
        this._prefix = prefix;
        this._suffix = suffix;
    }
    Object.defineProperty(RangeModel.prototype, "value", {
        get: function () {
            return this._value;
        },
        set: function (value) {
            this._value = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(RangeModel.prototype, "width", {
        get: function () {
            return this._width;
        },
        set: function (value) {
            this._width = value !== null && value !== void 0 ? value : 0;
        },
        enumerable: false,
        configurable: true
    });
    RangeModel.prototype.getInnerPadding = function () {
        return this._isSm ? 16 : 24;
    };
    RangeModel.prototype.getRangeWidth = function () {
        return this._max - this._min;
    };
    RangeModel.prototype.getInnerWidth = function () {
        return this._width - this.getInnerPadding();
    };
    RangeModel.prototype.calculRatio = function (value) {
        return (value - this._min) / this.getRangeWidth();
    };
    RangeModel.prototype.getRatio = function () {
        return this.calculRatio(this._value);
    };
    RangeModel.prototype.getClassName = function (customClassName) {
        var rangeClass = "fr-range ";
        if (this._step) {
            rangeClass += "fr-range--step ";
        }
        if (this._isSm) {
            rangeClass += "fr-range--sm ";
        }
        if (customClassName) {
            rangeClass += customClassName;
        }
        return rangeClass;
    };
    RangeModel.prototype.getProgressStyle = function () {
        var innerWidth = this.getInnerWidth();
        return {
            "--progress-right": "".concat((innerWidth * this.getRatio() + this.getInnerPadding() * 0.5).toFixed(2), "px"),
        };
    };
    RangeModel.prototype.getStepStyle = function () {
        if (this._step !== undefined) {
            var steps = this.getRangeWidth() / this._step;
            var stepWidth = this.getInnerWidth() / steps;
            if (stepWidth < 1 || !isFinite(stepWidth))
                stepWidth = 4;
            while (stepWidth < 4) {
                stepWidth *= 2;
            }
            return {
                "--step-width": "".concat(stepWidth, "px"),
            };
        }
        return {};
    };
    RangeModel.prototype.getRangeString = function () {
        return this.formatString(this._value);
    };
    RangeModel.prototype.getMinString = function () {
        return this.formatString(this._min);
    };
    RangeModel.prototype.getMaxString = function () {
        return this.formatString(this._max);
    };
    RangeModel.prototype.formatString = function (val) {
        return "".concat(this._prefix || "").concat(val.toString()).concat(this._suffix || "");
    };
    return RangeModel;
}());
export default RangeModel;
